import React from 'react';
import { RouterProps } from '../shared/types/route.type';
import { AppRoutes } from './routeConstants/appRoutes';
import CompanySetup from '../views/CompanySetup';
import PrivateRoute from '../shared/components/PrivateRoute';
import ActivityDataEntry from 'views/ActivityDataEntry';
import CategoryOneComponent from 'views/ActivityDataEntry/ScopeUpstreamList/CategoryOneComponent';
import Category4and9 from 'views/Scope3/Category4&9';
import Category5 from 'views/Scope3/Category5';
import Category6 from 'views/Scope3/Category6';

export const companySetupRoutes: RouterProps[] = [
  {
    path: AppRoutes.COMPANY_SETUP,
    element: (
      <PrivateRoute>
        <CompanySetup />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.ACTIVITY_DATA_ENTRY,
    element: (
      <PrivateRoute>
        <ActivityDataEntry />
      </PrivateRoute>
    ),
  },

  {
    path: AppRoutes.CATEGORY_5,
    element: (
      <PrivateRoute>
        <Category5 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_4,
    element: (
      <PrivateRoute>
        <Category4and9 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_6,
    element: (
      <PrivateRoute>
        <Category6 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.SCOPE_3_CATEGORY_1,
    element: (
      <PrivateRoute>
        <CategoryOneComponent />
      </PrivateRoute>
    ),
  }
]; 